import {OrderDto} from '../types'

/**
 * Builds analytics data for order change tracking.
 * Captures essential order identifiers for analytics purposes.
 */
export const buildOrderChangeAnalyticsData = (order: OrderDto) => ({
  orderId: order.orderId
})

export type OrderChangeAnalyticsData = ReturnType<typeof buildOrderChangeAnalyticsData>
